import {
  FaHome,
  FaUsers,
  FaLink,
  FaInfoCircle,
  FaRegSmile,
  FaSignOutAlt,
} from "react-icons/fa";
import { useNavigate, useMatch } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useSelector } from "react-redux";
import { Dialog, DialogActions, DialogTitle } from "@mui/material";

export default function BottomAppBar() {
  const { user } = useSelector((state) => state.Language);
  const [openModal, setOpenModal] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const Home = useMatch("/");
  const Team = useMatch("/team");
  const About = useMatch("/about");

  function onClickHandler() {
    if (user && user !== "Guest User") {
      navigate("/mood");
    } else {
      setOpenModal(true);
    }
  }

  function onClickLoginHandler() {
    navigate("/login");
  }

  return (
    <>
      <div className="bg-secondary rounded-t-2xl fixed bottom-0 top-auto w-full">
        <ul className="flex justify-between px-5 sm:py-3 py-4 lg:pt-5 lg:px-7">
          <li
            className={`text-xl ${
              Home ? "text-lightDefault" : "text-white"
            }  text-center `}
            onClick={() => navigate("/home")}
          >
            <FaHome className="mx-auto text-2xl sm:text-lg md:text-3xl lg:text-4xl" />
            <p className="text-xs lg:text-base md:text-sm font-semibold mb-0">
              {t("HOME")}
            </p>
          </li>
          <li
            className={`text-xl  ${
              Team ? "text-lightDefault" : "text-white"
            }  text-center `}
            onClick={() => navigate("/team")}
          >
            <FaUsers className="mx-auto text-2xl sm:text-lg md:text-3xl lg:text-4xl" />
            <p className="text-xs lg:text-base font-semibold md:text-sm mb-0">
              {t("TEAM")}
            </p>
          </li>
          <li
            className="absolute -top-7 lg:-top-12 left-[44%] "
            onClick={onClickHandler}
          >
            <FaRegSmile className=" text-6xl sm:text-5xl lg:text-7xl md:text-6xl text-white p-2 border-4   border-[#ccc] bg-default rounded-full" />
          </li>
          <li
            className="text-lightDefault text-center text-xl"
            onClick={() => navigate("/link")}
          >
            <FaLink className="mx-auto text-2xl sm:text-lg  md:text-3xl lg:text-4xl" />
            <p className="text-xs lg:text-base font-semibold md:text-sm mb-0">
              {t("LINKS")}
            </p>
          </li>
          <li
            className={`text-xl ${
              About ? "text-lightDefault" : "text-white"
            }  text-center `}
            onClick={() => navigate("/about")}
          >
            <FaInfoCircle className="mx-auto text-2xl sm:text-lg md:text-3xl  lg:text-4xl" />
            <p className="text-xs lg:text-base font-semibold md:text-sm mb-0">
              {t("ABOUT")}
            </p>
          </li>
        </ul>
      </div>

      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          className="flex modal-justify-center flex-col items-center modal-content"
        >
          <FaSignOutAlt className="text-center text-[3.5rem] text-gray-300 my-3" />
          <p className="text-base mb-0 text-center text-gray-600 font-normal">
            {t("LOGIN_TO_REGISTER_YOUR_MOOD")}
          </p>
        </DialogTitle>
        <DialogActions className="flex modal-justify-center">
          <button
            type="button"
            className="bg-gray-400  uppercase text-xs mt-4 mb-2 px-4 rounded-md text-white py-2 shadow shadow-slate-400 "
            onClick={() => setOpenModal(false)}
            autoFocus
          >
            {t("SKIP")}
          </button>
          <button
            type="button"
            className="bg-default  uppercase text-xs mt-4 mb-2 px-4 rounded-md text-white py-2 shadow shadow-slate-400 "
            onClick={onClickLoginHandler}
            autoFocus
          >
            {t("LOGIN")}
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
}
